/**
 * Created by Andrey Popov on 16.10.2026
 */

// the advertised game goes to itemId
cleverapps.override(cleverapps.EVENTS, {
    NOFILL_SHOWN: "nofill_shown",
    NOFILL_PLAY: "nofill_play",
    NOFILL_SKIP: "nofill_skip",
    NOFILL_WATCHED: "nofill_watched"
});
